import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { BuildingService } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { ExternalTenantStatisticsFilter } from '@pages/tenant-statistics-page/tenant-statistics-page.component';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';
import { repairTasksVisible } from '@/utils/repair-task-visibility';

@Component({
  standalone: false,
  selector: 'wr-cooperative-statistics-charts',
  templateUrl: './tenant-statistics-charts.component.html',
  styleUrls: ['./tenant-statistics-charts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantStatisticsChartsComponent {

  private readonly buildingService = inject(BuildingService);

  @Input()
  @Tracked()
  filter?: ExternalTenantStatisticsFilter;

  readonly repairTasksVisible = repairTasksVisible();

  readonly loading = loader();

  readonly buildingCount = asyncComputed(() => {
    const tenantId = this.filter?.tenantId;
    return tenantId ? this.buildingService.getBuildingCountByTenant(tenantId) : 0;
  }, 0, this.loading);

  readonly totalArea = asyncComputed(() => {
    const tenantId = this.filter?.tenantId;
    return tenantId ? this.buildingService.getTotalBuildingAreaByTenant(tenantId) : 0;
  }, 0, this.loading);

  roundArea(number: number): string {
    return String(Math.round(number * 100) / 100);
  }
}
